<app-data-grid
  [dataItems]="changesets"
  [columns]="columns"
  [fontSize]="fontSize"
  [state]="state"
  [group]="group"
  [filterable]="'menu'"
  (dataStateChange)="onDataStateChanged($event)"
>
  <ng-template #toolbarTemplate>
    <div class="k-toolbar k-grid-toolbar custom-toolbar">
      <h4 class="m-0">Show</h4>
      &nbsp;
      <div class="filters-section">
        <kendo-dropdownlist
          [data]="types"
          [(ngModel)]="selectedType"
          textField="name"
          valueField="id"
          (ngModelChange)="setDefaultState()"
        ></kendo-dropdownlist>
      </div>
      <h4 class="m-0">for reporting unit</h4>
      &nbsp;
      <kendo-dropdownlist
        [data]="reportingUnits.data"
        [defaultItem]="defaultReportingUnit"
        [(ngModel)]="selectedReportingUnit"
        textField="ruNm"
        valueField="ruNo"
        (ngModelChange)="fetchRestaurants()"
      ></kendo-dropdownlist>
      <h4 class="m-0">and restaurant</h4>
      &nbsp;
      <kendo-dropdownlist
        [data]="restaurants"
        [defaultItem]="defaultRestaurant"
        [(ngModel)]="selectedRestaurant"
        textField="name"
        valueField="id"
        (ngModelChange)="setDefaultState()"
      ></kendo-dropdownlist>

      <button
        size="small"
        themeColor="primary"
        kendoButton
        (click)="setDefaultState()"
      >
        <fa-icon [icon]="['fas', 'rotate-right']"></fa-icon>
      </button>

      <kendo-toolbar-spacer></kendo-toolbar-spacer>

      <div class="buttons-section">
        <app-grid-manager-toolbar
          [showConfig]="false"
          [fontSize]="fontSize"
          (fontSizeChange)="fontSize = $event; setDefaultState()"
          [columns]="columns"
          [showImport]="[]"
          [showExport]="[]"
        ></app-grid-manager-toolbar>
      </div>
    </div>
  </ng-template>
  <ng-template
    columnTemplate
    let-row="row"
    let-column="column"
    field="transmitStatus"
  >
    <ng-container [ngSwitch]="row[column.field]">
      <fa-icon
        *ngSwitchCase="'Success'"
        [icon]="['fas', 'check-circle']"
        class="text-success"
      ></fa-icon>
      <fa-icon
        *ngSwitchCase="'Updated'"
        [icon]="['fas', 'check-circle']"
        class="text-success"
      ></fa-icon>
      <fa-icon
        *ngSwitchCase="'ItemUpdateFailed'"
        [icon]="['fas', 'times-circle']"
        class="text-danger"
        title="Item update failed"
      ></fa-icon>
      <fa-icon
        *ngSwitchCase="'DeliveryUpdateFailed'"
        [icon]="['fas', 'times-circle']"
        class="text-danger"
        title="Delivery update failed"
      ></fa-icon>
      <fa-icon
        *ngSwitchCase="'DeliveryAvailabilityFailed'"
        [icon]="['fas', 'times-circle']"
        class="text-danger"
        title="Delivery availability update failed"
      ></fa-icon>
      <fa-icon
        *ngSwitchCase="'AllUpdatesFailed'"
        [icon]="['fas', 'times-circle']"
        class="text-danger"
        title="All updates failed"
      ></fa-icon>
      <fa-icon
        *ngSwitchCase="'Pending'"
        [icon]="['fas', 'hourglass-half']"
        class="text-warning"
      ></fa-icon>
      <fa-icon
        *ngSwitchCase="'Scheduled'"
        [icon]="['fas', 'calendar-check']"
        class="text-success"
      ></fa-icon>
      <fa-icon
        *ngSwitchCase="'Canceled'"
        [icon]="['fas', 'ban']"
        class="text-danger"
      ></fa-icon>
      <fa-icon
        *ngSwitchDefault
        [icon]="['fas', 'question-circle']"
        class="text-muted"
      ></fa-icon>
    </ng-container>
  </ng-template>

  <ng-template
    columnTemplate
    let-row="row"
    let-column="column"
    field="dataStatus"
  >
    <div class="k-d-flex k-justify-content-between">
      <ng-container [ngSwitch]="row[column.field]">
        <fa-icon
          *ngSwitchCase="'Success'"
          [icon]="['fas', 'check-circle']"
          class="text-success"
        ></fa-icon>
        <fa-icon
          *ngSwitchCase="'Updated'"
          [icon]="['fas', 'check-circle']"
          class="text-success"
        ></fa-icon>
        <fa-icon
          *ngSwitchCase="'ItemUpdateFailed'"
          [icon]="['fas', 'times-circle']"
          class="text-danger"
          title="Item update failed"
        ></fa-icon>
        <fa-icon
          *ngSwitchCase="'DeliveryUpdateFailed'"
          [icon]="['fas', 'times-circle']"
          class="text-danger"
          title="Delivery update failed"
        ></fa-icon>
        <fa-icon
          *ngSwitchCase="'DeliveryAvailabilityFailed'"
          [icon]="['fas', 'times-circle']"
          class="text-danger"
          title="Delivery availability update failed"
        ></fa-icon>
        <fa-icon
          *ngSwitchCase="'AllUpdatesFailed'"
          [icon]="['fas', 'times-circle']"
          class="text-danger"
          title="All updates failed"
        ></fa-icon>
        <fa-icon
          *ngSwitchCase="'Pending'"
          [icon]="['fas', 'hourglass-half']"
          class="text-warning"
        ></fa-icon>
        <fa-icon
          *ngSwitchCase="'Scheduled'"
          [icon]="['fas', 'calendar-check']"
          class="text-success"
        ></fa-icon>
        <fa-icon
          *ngSwitchCase="'Canceled'"
          [icon]="['fas', 'ban']"
          class="text-danger"
        ></fa-icon>
        <fa-icon
          *ngSwitchDefault
          [icon]="['fas', 'question-circle']"
          class="text-muted"
        ></fa-icon>
      </ng-container>
    </div>
  </ng-template>

  <ng-template
    groupColumnHeaderTemplate
    field="restaurantName"
    let-group="group"
    let-column="column"
  >
    <div class="k-d-flex k-justify-content-between k-gap-md">
      <span>{{ group.value }} </span>
      <button
        size="small"
        themeColor="success"
        kendoButton
        (click)="refreshRestaurant(group.value)"
      >
        Refresh
      </button>
      <button size="small" themeColor="primary" kendoButton [disabled]="true">
        Contact PAR Support
      </button>
    </div>
  </ng-template>
</app-data-grid>
